import { SET_LIST, SET_CURRENT_LIST, SET_START_INDEX } from "./_store/types";

export async function asyncData(store) {
    if (
        this.listingDetail &&
        this.listingDetail.info &&
        this.listingDetail.info.id
    ) {
        let result = await this.axiosIns
            .get('/api-site/listing/recommended-listings/', {
                params: {
                    pageSize: this.size,
                    detailId: this.listingDetail.info.id
                }
            });
        
        let list = result.data.listings;
        if (list) {
            list.forEach(item => {
                Object.assign(item, item.listingPreview);
            });
            store[SET_LIST](list);
            store[SET_CURRENT_LIST](list.slice(0, 3));
            store[SET_START_INDEX](3);
        }
    }
}